import { AUTH_TOKEN_LS_KEY } from './constants';

class LocalStorageService {
  setAuthKey(authKey: string) {
    localStorage.setItem(AUTH_TOKEN_LS_KEY, authKey);
  }

  getAuthKey() {
    return localStorage.getItem(AUTH_TOKEN_LS_KEY);
  }

  clearAuthKey() {
    return localStorage.removeItem(AUTH_TOKEN_LS_KEY);
  }
}

export const localStorageService = new LocalStorageService();
